import React from "react";
import { Col } from "antd";
import RenderComponent from "components/renderComponent";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

type IRegister = {
  isAllowed: boolean;
  attendanceShowDrawerCheckinRegister: (...args) => void;
};
export const Register = ({ isAllowed, attendanceShowDrawerCheckinRegister }: IRegister): JSX.Element => (
  <RenderComponent isRender={isAllowed}>
    <Col flex="220px" style={S.AddButtonCol}>
      <S.AddButton onClick={attendanceShowDrawerCheckinRegister}>{useTranslation({ id: "create_new_vehicle" })}</S.AddButton>
    </Col>
  </RenderComponent>
);
